import styles from './style.postcss';

import React from 'react';
import { pure } from 'recompose';
import PropTypes from 'prop-types';
import { Set } from 'immutable';
import classnames from 'classnames';
import { Grid, Checkbox, StudentCard } from 'omni-common-ui';

export const StudentPicker = ({
    students,
    selectedStudentIds,
    onStudentCheckedOrUnchecked,
}) => <div className={
    styles.StudentPicker}>
  <Grid className={styles.StudentPicker_grid}>
    <Grid.Group>
      {students.map((member) => {
        const studentId = member.studentGeneralInfo.id;
        const checkboxId = `StudentPicker#checkbox-${studentId}`;
        return <Grid.Item key={studentId}
            className={styles.StudentPicker_item}
            xs={12}
            sm={6}
            lg={4}>
          <label className={classnames(
            styles.StudentPicker_student, {
              [styles.__selected]: selectedStudentIds.has(studentId),
            })}
              htmlFor={checkboxId}>
            <Checkbox name="studentIds[]"
                id={checkboxId}
                value={studentId}
                checked={selectedStudentIds.has(studentId)}
                onChange={(isChecked) => {
                  onStudentCheckedOrUnchecked &&
                  onStudentCheckedOrUnchecked(studentId, isChecked);
                }} />
            <StudentCard borderless backgroundless>
              <StudentCard.Profile className={
                    styles.StudentPicker_student_profile}
                  name={member.studentGeneralInfo.firstName}
                  surname={member.studentGeneralInfo.lastName}
                  localName={member.studentGeneralInfo.localName}
                  avatarUrl={member.studentGeneralInfo.avatarUrl}
                  gender={member.studentGeneralInfo.gender} />
            </StudentCard>
          </label>
        </Grid.Item>;
      })}
    </Grid.Group>
  </Grid>
</div>;

StudentPicker.propTypes = {
  students: PropTypes.shape({
    map: PropTypes.func.isRequired,
  }).isRequired,
  selectedStudentIds: PropTypes.instanceOf(Set).isRequired,
  onStudentCheckedOrUnchecked: PropTypes.func,
};

StudentPicker.defaultProps = {
  selectedStudentIds: new Set(),
};

export default pure(StudentPicker);



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/Assignments/PersonalisedHomeworkFormCard/StudentPicker/index.jsx